import { Component, Input } from '@angular/core';

@Component({
  selector: 'botao-barra',
  templateUrl: 'botao-barra.html'
})
export class BotaoBarraComponent {


  @Input('text') text;

  constructor() {
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/botao-barra/botao-barra.ts